<template>
    <div class="form">
        <v-form
            ref="form"
            v-model="valid"
            lazy-validation
        >
                <v-layout row>
                    <div class="info-block">
                        Add info about new user
                    </div>
                </v-layout>
                <v-layout row v-if="errors !== null">
                    <v-flex md12>
                        <div class="content-wrapper">
                            <div class="error-block">
                                <div class="title">Errors</div>
                                <p v-html="errors"></p>
                            </div>
                        </div>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex md6>
                        <v-layout row>
                            <v-flex xs5>
                                <div class="label text-xs-right">
                                    <span class="text-xs-right">Username <span class="required">*</span></span>
                                </div>
                            </v-flex>
                            <v-flex xs7>
                                <v-text-field
                                    v-model="form.userName"
                                    label="Insert username"
                                    :rules="rules.userName"
                                    required
                                    outline
                                    single-line
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs5>
                                <div class="label text-xs-right">
                                    <span class="text-xs-right">Roles <span class="required">*</span></span>
                                </div>
                            </v-flex>
                            <v-flex xs7>
                                <v-select
                                    v-model="form.roles"
                                    :items="roles"
                                    :rules="rules.permissions"
                                    label="Choose roles"
                                    item-text="name"
                                    item-value="id"
                                    multiple
                                    required
                                    outline
                                    single-line
                                    :disabled="!hasAllRoles(['RoleView'])"
                                ></v-select>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs5>
                                <div class="label text-xs-right">
                                    <span class="text-xs-right">Permissions <span class="required">*</span></span>
                                </div>
                            </v-flex>
                            <v-flex xs7>
                                <v-select
                                    v-model="form.permissions"
                                    :items="permissionList"
                                    :rules="rules.permissions"
                                    label="Choose permissions"
                                    item-text="name"
                                    item-value="id"
                                    multiple
                                    required
                                    outline
                                    single-line
                                ></v-select>
                            </v-flex>
                        </v-layout>
                        <v-layout row v-if="hasAadLicense">
                            <v-flex xs5>
                                <div class="label text-xs-right">
                                    <span class="text-xs-right">Azure AD Identifier</span>
                                </div>
                            </v-flex>
                            <v-flex xs7>
                                <v-text-field
                                    v-model="form.azureAdId"
                                    label="Insert Azure AD Identifier"
                                    outline
                                    single-line
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row v-if="!isEditMode && !hasAadLicense">
                            <v-flex xs5>
                                <div class="label text-xs-right">
                                    <span class="text-xs-right">Password <span class="required">*</span></span>
                                </div>
                            </v-flex>
                            <v-flex xs7>
                                <v-text-field
                                    v-model="form.password"
                                    label="Insert password"
                                    :rules="isEditMode? rules.editModePassword: rules.password"
                                    :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                    :type="showPassword ? 'text' : 'password'"
                                    required
                                    outline
                                    single-line
                                    @click:append="showPassword = !showPassword"
                                    @keyup="validatePasswords"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row v-if="!isEditMode && !hasAadLicense">
                            <v-flex xs5>
                                <div class="label text-xs-right">
                                    <span class="text-xs-right">Confirm password <span class="required">*</span></span>
                                </div>
                            </v-flex>
                            <v-flex xs7>
                                <v-text-field
                                    v-model="rePassword"
                                    label="Repeat password"
                                    :append-icon="showRePassword ? 'visibility' : 'visibility_off'"
                                    :type="showRePassword ? 'text' : 'password'"
                                    required
                                    outline
                                    single-line
                                    @click:append="showRePassword = !showRePassword"
                                    @keyup="validatePasswords"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs5>
                                <div class="label text-xs-right">
                                    <span class="text-xs-right">Expires in</span>
                                </div>
                            </v-flex>
                            <v-flex xs7>
                                <date-picker
                                    v-model="form.expiresIn"
                                    placeholder="Pick date"
                                    :clearable="false"
                                    :default-value="new Date()"
                                    :disabled-date="disabledBeforeToday"
                                    type="date"
                                ></date-picker>
                            </v-flex>
                        </v-layout>

                    </v-flex>
                    <v-flex md6>
                    <v-layout row>
                            <v-flex xs5>
                                <div class="label text-xs-right">
                                    <span class="text-xs-right">First name <span class="required">*</span></span>
                                </div>
                            </v-flex>
                            <v-flex xs7>
                                <v-text-field
                                    v-model="form.firstName"
                                    label="Insert first name"
                                    :rules="rules.firstName"
                                    required
                                    outline
                                    single-line
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs5>
                                <div class="label text-xs-right">
                                    <span class="text-xs-right">Last name <span class="required">*</span></span>
                                </div>
                            </v-flex>
                            <v-flex xs7>
                                <v-text-field
                                    v-model="form.lastName"
                                    label="Insert last name"
                                    :rules="rules.lastName"
                                    required
                                    outline
                                    single-line
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs5>
                                <div class="label text-xs-right">
                                    <span class="text-xs-right">E-mail <span class="required">*</span></span>
                                </div>
                            </v-flex>
                            <v-flex xs7>
                                <v-text-field
                                    v-model="form.email"
                                    label="Insert e-mail"
                                    :rules="rules.email"
                                    required
                                    outline
                                    single-line
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs5>
                                <div class="label text-xs-right">
                                    <span class="text-xs-right">Phone number <span class="required">*</span></span>
                                </div>
                            </v-flex>
                            <v-flex xs7>
                                <v-text-field
                                    v-model="form.phoneNumber"
                                    label="Insert phone number"
                                    :rules="rules.phoneNumber"
                                    required
                                    outline
                                    single-line
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs5>
                                <div class="label text-xs-right">
                                    <span class="text-xs-right">Access for all sub organization</span>
                                </div>
                            </v-flex>
                            <v-flex xs7 shrink>
                                <v-checkbox
                                    v-model="form.accessForAllSubOrgs"
                                    :value="form.accessForAllSubOrgs"
                                ></v-checkbox>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-layout row class="buttons">
                        <v-flex xs5>
                            <sp-button @click.native="goBack" text="Go Back" small-icon icon="go-back" sp-class="go-back"></sp-button>
                        </v-flex>
                        <v-flex xs7 class="right text-xs-right">
                            <sp-button @click.native="validate" text="Save" icon="download"></sp-button>
                        </v-flex>
                    </v-layout>
                </v-layout>
        </v-form>
    </div>
</template>

<script>
import SpButton from '@/components/forms/Button'
import router from '@/router/routes'
import { mapGetters } from 'vuex'
import RolesApi from '@/api/RolesApi'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'

const rolesApi = new RolesApi()

export default {
    name: 'UserForm',
    components: {
        SpButton,
        DatePicker
    },
    props: {
        handler: {
            type: Function,
            required: true
        },
        form: {
            type: Object,
            required: true
        },
        hasAadLicense: {
            type: Boolean,
            required: false,
            default: false
        },
        isEditMode: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    data () {
        return {
            valid: false,
            errors: null,
            rePassword: '',
            showPassword: false,
            showRePassword: false,
            isDatePickerShow: false,
            fleets: [],
            roles: [],
            todaysDate: null,
            rules: {
                userName: [
                    v => ((v || '').trim().length && 3 <= v.trim().length && 100 >= v.trim().length) || 'Username must be at least 3 and less than 100 characters',
                    v => (v === v.trim()) || 'Username cannot have leading or trailing spaces'
                ],
                firstName: [
                    v => ((v || '').trim().length && 3 <= v.trim().length && 100 >= v.trim().length) || 'First name must be at least 3 and less than 100 characters',
                    v => (v.length && this.validateAlphabetical(v)) || 'First name must consist of letters without diacritics'
                ],
                lastName: [
                    v => ((v || '').trim().length && 3 <= v.trim().length && 100 >= v.trim().length) || 'Last name must be at least 3 and less than 100 characters',
                    v => (v.length && this.validateAlphabetical(v)) || 'Last name must consist of letters without diacritics'
                ],
                email: [
                    v => (v.length && this.validateEmail(v)) || 'Invalid e-mail format.'
                ],
                phoneNumber: [
                    v => (v.length && this.validatePhone(v)) || 'Invalid phone number format',
                    v => ((v || '').trim().length && 3 <= v.trim().length && 100 >= v.trim().length) || 'Phone number must be at least 3 and less than 100 characters'
                ],
                permissions: [
                    v => ((null != this.form.permissions && 0 < this.form.permissions.length) || (null != this.form.roles && 0 < this.form.roles.length)) || 'Permissions or roles are required'
                ],
                password: [
                    v => ((v || '').length && 4 <= v.length && 40 >= v.length) || 'Password must be at least 4 and less than 40 characters',
                    v => (v.length && v === this.rePassword) || 'Passwords must be the same.'
                ],
                editModePassword: [
                    v => {
                        if (0 === v.length) {
                            return true
                        }

                        return (6 <= v.length && v === this.rePassword) || 'Password must have at least 6 characters'
                    }
                ]
            }
        }
    },
    computed: {
        ...mapGetters('dictionaryModule', {
            getPermissions: 'getRoles',
        }),
        ...mapGetters('authModule', {
            getUserPermissions: 'getPermissions'
        }),
        permissionList () {
            return this.getPermissions.map(permission => {
                return {
                    ...permission,
                    disabled: 1 === permission.id && !this.hasAllRoles(['Admin'])
                }
            })
        }
    },
    mounted () {
        if (this.hasAllRoles(['RoleView'])) {
            this.getRoles()
        }

        this.todaysDate = moment().format('YYYY-MM-DD')
    },
    methods: {
        async validate () {
            if (null === this.form.accessForAllSubOrgs) {
                this.form.accessForAllSubOrgs = false
            }
            this.valid = this.$refs.form.validate()
            if (!this.valid) {
                return false
            }

            try {
                this.errors = null
                await this.handler(this.form)
            } catch (e) {
                this.errors = e.message
            }
        },
        goBack () {
            router.back()
        },
        validateEmail (email) {
            let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return re.test(String(email).toLowerCase())
        },
        validatePhone (phone) {
            let re = /^([0-9+()\- ]+)$/
            return re.test(String(phone).toLowerCase())
        },
        validateAlphabetical (value) {
            let re = /^[a-zA-Z]*$/
            return re.test(String(value))
        },
        validatePasswords () {
            this.valid = this.$refs.form.validate()
        },
        async getRoles () {
            const response = await rolesApi.getRoles();

            if (!response.isSuccess) {
                return
            }

            this.roles = response.payload.items
        },
        disabledBeforeToday (date) {
            const today = new Date()

            return date < today
        }
    }
}
</script>

<style scoped lang="scss">

.v-form > .container {
    padding: 0px 10px 0px 10px;
}

::v-deep .v-input__slot {
    .v-input__append-inner {
        margin: 12px 0 0 0 !important;
    }
}

::v-deep .mx-input {
    height: 45px;
}

</style>
